<template>
  <div class="navbar">
    <!-- 左侧：折叠按钮和面包屑 -->
    <div class="left">
      <el-icon class="collapse-btn" @click="toggleCollapse">
        <Fold v-if="!collapsed" />
        <Expand v-else />
      </el-icon>
      <breadcrumb />
    </div>
    
    <!-- 右侧：用户信息和操作 -->
    <div class="right">
      <el-tooltip content="全屏" effect="dark" placement="bottom">
        <el-icon class="action-icon" @click="toggleFullscreen">
          <FullScreen />
        </el-icon>
      </el-tooltip>
      
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="user-info">
          <el-avatar :size="32" :icon="UserFilled" />
          <span class="username">{{ userInfo.username || '管理员' }}</span>
          <el-icon><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="profile">个人中心</el-dropdown-item>
            <el-dropdown-item command="settings">系统设置</el-dropdown-item>
            <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Breadcrumb from './Breadcrumb.vue'

export default {
  name: 'Navbar',
  components: {
    Breadcrumb
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:collapsed'],
  setup(props, { emit }) {
    const router = useRouter()
    const userInfo = computed(() => {
      try {
        return JSON.parse(localStorage.getItem('userInfo') || '{}')
      } catch (error) {
        return {}
      }
    })
    
    const toggleCollapse = () => {
      emit('update:collapsed', !props.collapsed)
    }
    
    const toggleFullscreen = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    }
    
    const handleCommand = (command) => {
      switch (command) {
        case 'profile':
          router.push('/profile')
          break
        case 'settings':
          router.push('/settings')
          break
        case 'logout':
          ElMessageBox.confirm('确定要退出登录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
            router.push('/login')
            ElMessage.success('退出成功')
          })
          break
      }
    }
    
    return {
      toggleCollapse,
      toggleFullscreen,
      handleCommand,
      userInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  
  .left {
    display: flex;
    align-items: center;
    
    .collapse-btn {
      font-size: 20px;
      cursor: pointer;
      margin-right: 15px;
      color: #606266;
      
      &:hover {
        color: #409EFF;
      }
    }
  }
  
  .right {
    display: flex;
    align-items: center;
    gap: 20px;
    
    .action-icon {
      font-size: 20px;
      cursor: pointer;
      color: #606266;
      
      &:hover {
        color: #409EFF;
      }
    }
    
    .user-info {
      display: flex;
      align-items: center;
      cursor: pointer;
      
      .username {
        margin: 0 8px;
        font-size: 14px;
        color: #606266;
      }
      
      .el-icon {
        color: #909399;
      }
    }
  }
}
</style>
